import Paper from '@mui/material/Paper';
import CustomToolbar from './TableComponents/CustomToolbar';
import UserTable from './AdminTables/UserTable';

const UserDetails = ({ title }) => (
  <Paper style={{ height: '80vh', margin: 15, background: 'rgb(24, 70, 125)', color: 'rgb(255, 255, 255)' }}>
    <CustomToolbar
      title={title}
      icon
    />
    <Paper sx={{ margin: 2, overflow: 'hidden' }}>
      <UserTable />
    </Paper>
  </Paper>
);
export default UserDetails;
